<template>
  <div class="project">
    <a
      :href="link"
      rel="noopener noreferrer"
      target="_blank">
      <img
        class="project-screenshot"
        :src="require(`@/assets/${imageUrl}`)"/>
      <div class="project-name">{{ name }}</div>
      <div class="project-description">{{ description }}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Project',
  props: {
    description: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.project {
  background-color: #333;
  border-radius: 15px;
  box-shadow: 3px 3px 8px rgba(0, 0, 0, 0.6);
  cursor: pointer;
  flex: 1;
  margin: 20px;
  padding: 25px 30px 20px;
  &:hover { background-color: #292929; }
}

.project-screenshot {
  width: 100%;
}

.project-name {
  font-size: 18px;
  font-weight: 300;
  margin: 10px 0 2px;
}

.project-description {
  font-size: 12px;
}

a {
  color: inherit;
  text-decoration: none;
  &:hover { color: white; }
}
</style>
